import React, { useState, useCallback, useMemo } from 'react'
import { useInView } from 'react-intersection-observer'
import { m, LazyMotion, domAnimation } from "framer-motion"
import { EventCalendar } from './eventCalendar'
import { imgUrlConverter, heroBannerEvent } from '../../util/util'

export const HeroBanner = ({ appData:{customerdata}, appData:{storedata} }) => {

	const customerHeroBannerData = customerdata?.filter(data => data.contentType === "SchoolStoreHeroBanner")[0]
	const eventData = storedata?.schoolStoreEvents ? heroBannerEvent(storedata.schoolStoreEvents) : undefined

	let schoolStoreHeroBannerImageUrl, extendedName, mascotUrl, mascotName
	if (storedata && storedata.schoolStoreHeroBannerData) {
		schoolStoreHeroBannerImageUrl = storedata.schoolStoreHeroBannerData.schoolStoreHeroBannerImageUrl
		extendedName = storedata.schoolStoreHeroBannerData.extendedName
		mascotUrl = storedata.schoolStoreHeroBannerData.mascotUrl
		mascotName = storedata.schoolStoreHeroBannerData.mascotName
	}

	const [isMascot, setIsMascot] = useState(mascotUrl)
	/* const [ref, inView] = useInView({
        threshold: 0,
    }) */

	const onErrorHanddler = useCallback(
		() => {
			setIsMascot(false)
		},
		[],
	)

	const title = useMemo(() => {
		if (mascotName && mascotName !== 'null') {
			return `Hello, ${mascotName}!`
		} else if (!storedata && window.location.pathname.split("/")[5]) {
			return `Hello, ${window.location.pathname.split("/")[5].replace(/,/g, ' ')}!`
		} else {
			return 'Hello!'
		}
	}, [storedata]) 

	const heroImage = useMemo(()=>{
		if (eventData?.environment !== 'ONCAMPUS_APPT_EVENT' && eventData?.heroDesktopImgUrl) {
			return <img rel="preload" src={imgUrlConverter(eventData.heroDesktopImgUrl)} alt="Banner background image" />
		} else if (customerHeroBannerData) {
			return (
				<picture>
					<source media="(min-width: 1200px)" srcSet={imgUrlConverter(customerHeroBannerData.imageUrl.xl)} />
					<source media="(min-width: 1024px)" srcSet={imgUrlConverter(customerHeroBannerData.imageUrl.lg)} />
					<source media="(min-width: 768px)" srcSet={imgUrlConverter(customerHeroBannerData.imageUrl.md)} />
					<source media="(min-width: 576px)" srcSet={imgUrlConverter(customerHeroBannerData.imageUrl.sm)} />
					<img rel="preload" src={imgUrlConverter(customerHeroBannerData.imageUrl.xl)} alt={customerHeroBannerData && customerHeroBannerData.imageAltText} />
				</picture>
			)
		} else if (schoolStoreHeroBannerImageUrl) {
			return <img rel="preload" src={imgUrlConverter(schoolStoreHeroBannerImageUrl)} alt="Banner background image" />
		} else {
			return null
		}
	}, [eventData, customerHeroBannerData])
	
	return (
		<LazyMotion features={domAnimation}>
			<div 
				className={!eventData ? 'school-banner no-event' : 'school-banner'} 
				// ref={ref}
			>
				<div className="img-wrapper">
					{ heroImage }
				</div>
				<m.div 
					className="overlay"
					animate={{
						opacity: [0, 1],
						transition: {
							duration: .5
						}
					}}
				>
					<div className="inner" style={!eventData ? {padding:0} : null}>
						<m.div 
							animate={{
								opacity: [0, 1],
								transition: {
									delay: .5,
									duration: .5,
								},
							}}
							className={ isMascot ? "logo" : "logo no-logo"}
						>
							{ 
								isMascot && <img src={imgUrlConverter(mascotUrl)} onError={onErrorHanddler} alt="School Mascot" />
							}
						</m.div>
						<div>
							<m.h1 
								animate={{
									y: [15, 0],
									opacity: [0, 1],
									transition: {
										delay: .8,
										duration: .3,
									},
								}}
							>
									{ title }
							</m.h1>
							<ul>
								<m.li 
									animate={{
										y: [15, 0],
										opacity: [0, 1],
										transition: {
											delay: 1.1,
											duration: .3,
										},
									}}
								>
										{ extendedName }
								</m.li>
							</ul>
						</div>
					</div>
					{ eventData && eventData.name && <EventCalendar eventData={eventData} storedata={storedata} /> }
				</m.div>
			</div>
		</LazyMotion>
		
	)
}

export default HeroBanner